import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withStyles} from 'material-ui/styles';
import styles from './style/styles';
import StaffEditForm from './forms/StaffEditForm';
import {fetchImageRatios} from '../images/thunks';
import {fetchDestinations} from '../taxonomy/thunks';
import {
    fetchJobTitles,
    fetchStaffSites,
    updateStaff,
    fetchStaffTitles,
    fetchStaffTeams,
    fetchProjectsByDestination
} from './thunks';
import {
    changeTitle, changeJobs, changeName, changeFirstName, changeStaffTeams, changeStaffSites,
    changeStaffDestinations, changeStaffDescription, projectRemoveForDestination, projectAddForDestination,
    deleteImage, updateCroppedImage, updateImage, updateImageMeta
} from './actions';
import {showErrMsgPopup} from '../../components/helpers/helpers';

class StaffCreateMember extends Component {
    componentWillMount() {
        this.props.fetchDestinations();
        this.props.fetchJobTitles();
        this.props.fetchStaffSites();
        this.props.fetchStaffTitles();
        this.props.fetchStaffTeams();
        this.props.fetchImageRatios();
    }

    handleUpdateStaffSubmit() {
        let imageHasCrop = this.props.staffImage && this.props.staffImage.new && !this.props.staffImage.croppedImage;
        imageHasCrop ? showErrMsgPopup("Cropping the staff image is mandatory! Please click on it in order to CROP it.") : this.props.updateStaff(this.props.staffMember);
    }

    render() {
        return (
            this.props.staffMember.id !== undefined &&
            <StaffEditForm
                staffMember={this.props.staffMember}
                destinations={this.props.destinations}
                jobs={this.props.allJobs}
                sites={this.props.allSites}
                titles={this.props.allTitles}
                teams={this.props.allTeams}
                classes={this.props.classes}
                touched={this.props.touched}
                loading={this.props.loading}
                selectedTitle={this.props.selectedTitle}
                selectedJobs={this.props.selectedJobs}
                selectedName={this.props.selectedName}
                selectedFirstName={this.props.selectedFirstName}
                selectedStaffTeams={this.props.selectedTeams}
                selectedSites={this.props.selectedSites}
                selectedDescription={this.props.selectedDescription}
                selectedDestinations={this.props.selectedDestinations}
                selectedDestinationId={this.props.selectedDestinationId}
                onTitleChange={this.props.changeTitle}
                onDescriptionChange={this.props.changeStaffDescription}
                onNameChange={this.props.changeName}
                onTeamsChange={this.props.changeStaffTeams}
                onStaffSitesChange={this.props.changeStaffSites}
                onDestinationChange={this.props.changeStaffDestinations}
                onFirstNameChange={this.props.changeFirstName}
                onJobsChange={this.props.changeJobs}
                fetchProjectsByDestination={this.props.fetchProjectsByDestination}
                allProjectsByDestination={this.props.allProjectsByDestination}
                projectAddForDestination={this.props.projectAddForDestination}
                projectRemoveForDestination={this.props.projectRemoveForDestination}
                onSubmit={this.handleUpdateStaffSubmit.bind(this)}
                staffImage={this.props.staffImage}
                imageRatios={this.props.imageRatios.staff}
                onUpdateImageField={
                    (image) => this.props.updateImage(image)
                }
                onDeleteImageField={
                    (image) => this.props.deleteImage()
                }
                onCropImage={(image, imageUrlBlob, imageBlobObject) => {
                    this.props.updateCroppedImage(image, imageUrlBlob, imageBlobObject);
                }}
                onImageMetaUpdate={(imageMeta) => {
                    this.props.updateImageMeta(imageMeta);
                }}
            />
        )
    }
}

const mapStateToProps = state => ({
    destinations: state.taxonomy.allDestinations,
    allJobs: state.staff.allJobs,
    allSites: state.staff.allSites,
    allTitles: state.staff.allTitles,
    allTeams: state.staff.allTeams,
    selectedTitle: state.staff.staffMember.title_id,
    selectedJobs: state.staff.staffMember.jobs,
    selectedName: state.staff.staffMember.name,
    selectedDescription: state.staff.staffMember.description,
    selectedFirstName: state.staff.staffMember.firstname,
    selectedTeams: state.staff.staffMember.teams,
    selectedSites: state.staff.staffMember.sites,
    selectedDestinations: state.staff.staffMember.products,
    selectedDestinationId: state.staff.selectedDestinationId,
    allProjectsByDestination: state.staff.allProjectsByDestination,
    staffMember: state.staff.staffMember,
    staffImage: state.staff.staffMember.image,
    imageRatios: state.images.ratios,
    touched: state.staff.touched,
    loading: state.layout.ajaxCallsInProgress > 0,
});

export default connect(mapStateToProps, {
    fetchDestinations,
    fetchJobTitles,
    fetchStaffSites,
    updateStaff,
    fetchStaffTitles,
    fetchStaffTeams,
    changeTitle,
    changeJobs,
    changeName,
    changeFirstName,
    changeStaffTeams,
    changeStaffSites,
    changeStaffDestinations,
    fetchProjectsByDestination,
    changeStaffDescription,
    projectAddForDestination,
    projectRemoveForDestination,
    updateCroppedImage,
    updateImageMeta,
    updateImage,
    deleteImage,
    fetchImageRatios
})(withStyles(styles)(StaffCreateMember));


// WEBPACK FOOTER //
// ./src/containers/staff/StaffEditContent.jsx